// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

declare const api_base_url;

export const environment = {
  baseUrl: 'http://localhost:4200',
    production: false,
    stripe: 'pk_test_hFFilUsoQdirjjsYMNt4PYmW00bMub1Cey',
    api_base_url: api_base_url,
    versione: "2.0.1",
    buildDate: "2026-07-29T09:28:58.773Z"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
